import React from 'react';

interface IListFooterProps {
    children?: React.ReactNode;
}

export const ListFooter: React.FC<IListFooterProps> = ({ children }) => {
    return <div className="list-footer">{children}</div>;
};
